export function lineSegmentIntersectsCircle({ x1, y1, x2, y2, cx, cy, r }) {
  const dx = x2 - x1
  const dy = y2 - y1

  const a = dx * dx + dy * dy

  if (a === 0) return distance(x1, y1, cx, cy) <= r

  const b = 2 * (dx * (x1 - cx) + dy * (y1 - cy))
  const c = (x1 - cx) * (x1 - cx) + (y1 - cy) * (y1 - cy) - r * r

  const discriminant = b * b - 4 * a * c

  if (discriminant < 0) return false

  const t1 = (-b + Math.sqrt(discriminant)) / (2 * a)
  const t2 = (-b - Math.sqrt(discriminant)) / (2 * a)

  if ((t1 >= 0 && t1 <= 1) || (t2 >= 0 && t2 <= 1)) return true

  return false
}

function distance(x1, y1, x2, y2) {
  return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1))
}
